import React from 'react';
import {
    ServiceP,
    ServicesCard,
    ServicesContainer,
    ServicesH1,
    ServicesH2,
    ThreeWrapper, WhiteH1
} from "./FormsElements";
import {
    CardYoutubeWrap,
    InfoContainer
} from "../InfoSection/InfoElements";

const Forms1099Details = () => {
    return (
        <>
        <ServicesContainer id='forms1099'>
            <ServicesH1>1099 Forms</ServicesH1>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>1099-NEC</ServicesH2>
                    <ServiceP>Nonemployee compensation</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>1099-MISC</ServicesH2>
                    <ServiceP>Miscellaneous Information</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>1099-K</ServicesH2>
                    <ServiceP>Payment Card & Transactions</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 1099-INT</ServicesH2>
                    <ServiceP>Interest Income</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099-DIV</ServicesH2>
                    <ServiceP>Dividends and Distributions</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099-R</ServicesH2>
                    <ServiceP>Distributions From</ServiceP>
                </ServicesCard>
                </ThreeWrapper>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 1099-S</ServicesH2>
                    <ServiceP>Income on rental or investment property</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099 PATR</ServicesH2>
                    <ServiceP>Taxable Distributions Received From Cooperatives</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099-SA</ServicesH2>
                    <ServiceP>Report distributions from a health savings account</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
                <ThreeWrapper>
                    <ServicesCard>
                        <ServicesH2>Form 1099-G</ServicesH2>
                        <ServiceP>Unemployment compensation</ServiceP>
                    </ServicesCard>
                    <ServicesCard>
                        <ServicesH2>Form 1099-B</ServicesH2>
                        <ServiceP>Proceeds from Broker</ServiceP>
                    </ServicesCard>
                    <ServicesCard>
                        <ServicesH2>Form 1099-C</ServicesH2>
                        <ServiceP>Cancellation of Debt</ServiceP>
                    </ServicesCard>
            </ThreeWrapper>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 1099-LTC</ServicesH2>
                    <ServiceP>Report Long-Term Care and Accelerated Death Benefits</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099-Q</ServicesH2>
                    <ServiceP>Report distributions made from Coverdell Education savings Plan</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099-A</ServicesH2>
                    <ServiceP>Acquisition or Abandonment of Secured Property
                    </ServiceP>
                </ServicesCard>
            </ThreeWrapper>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 1099-OID</ServicesH2>
                    <ServiceP>Report the Original Issue Discount</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form W-2G</ServicesH2>
                    <ServiceP>Report Certain Gambling Winnings</ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 1099-Corrections</ServicesH2>
                    <ServiceP>File corrections in your Form 1099</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
        </ServicesContainer>
    <InfoContainer lightBg={false} >
        <ServicesContainer>
            <WhiteH1>How to E-file 1099 Form Online</WhiteH1>
            <CardYoutubeWrap>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/OiByE_cMoeo" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </CardYoutubeWrap>
        </ServicesContainer>
    </InfoContainer>
        </>
    );
};

export default Forms1099Details;
